<template>
  <div class="page-col">
    <div class="page-main">
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center py-1 px-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #1f7a5c 0%, #2d9d78 100%);">
            <i class="fa fa-flask text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'" style="font-size: 1.15rem;">Produção por Fórmula</h4>
            <small class="text-muted small">Cadastro e manutenção de fórmulas de produção</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 py-1 px-3 w-100 w-md-auto justify-content-end">
          <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2 flex-wrap">
            <b-button-group class="mr-2 d-none d-lg-inline-flex">
              <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros avançados">
                <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro" v-b-tooltip.hover title="Limpar filtros">
                <i class="fa fa-ban"></i>
              </b-button>
            </b-button-group>

            <div class="d-flex align-items-center px-2 border-left mr-2 form-search-wrapper">
              <b-form-input
                v-model="textoPesquisa"
                placeholder="Buscar descrição da fórmula..."
                class="shadow-xs"
                style="font-size: 0.9rem;"
                @keydown.enter.native="pesquisar">
              </b-form-input>
            </div>

            <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="pesquisar">
              <i class="fa fa-search mr-1"></i>
              <span class="d-none d-sm-inline">FILTRAR</span>
            </b-button>
          </div>

          <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm btn-adicionar-responsive" @click.stop.prevent="novo">
            <i class="fa fa-plus-circle mr-1"></i>
            <span class="d-none d-sm-inline">Nova Fórmula</span>
          </b-button>
        </div>
      </div>

      <b-collapse v-model="filtroAvancado">
        <div class="px-4 pb-4">
          <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
            <b-row align-v="end">
              <b-col md="5">
                <label class="small font-weight-bold text-muted">Produto Final</label>
                <ProducaoFormulaProdutoDropDown
                  v-model="filtroProdutoId"
                  modo="produto-final"
                  :idInicial="filtroProdutoId"
                  place="Pesquise o produto final...">
                </ProducaoFormulaProdutoDropDown>
              </b-col>
              <b-col md="3">
                <label class="small font-weight-bold text-muted">Situação</label>
                <b-form-select v-model="filtroSituacao" class="shadow-xs rounded-pill">
                  <b-form-select-option v-for="opt in situacaoOptions" :key="opt.value" :value="opt.value">
                    {{ opt.text }}
                  </b-form-select-option>
                </b-form-select>
              </b-col>
              <b-col md="4">
                <div class="d-flex justify-content-md-end mt-3 mt-md-0">
                  <b-button variant="primary" pill class="px-4 font-weight-bold" @click="pesquisar">
                    <i class="fa fa-search mr-1"></i> Aplicar filtros
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-collapse>

      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table
              ref="tbl"
              class="mb-0 table-finance"
              primary-key="ID"
              :head-variant="isDark ? 'dark' : 'light'"
              :dark="isDark"
              show-empty
              empty-text="Nenhuma fórmula encontrada"
              responsive
              :sticky-header="stickyHeight"
              hover
              small
              :busy.sync="isBusy"
              :items="itensFiltrados"
              :fields="colunas"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="clicarLinha"
              @row-dblclicked="edit"
              :tbody-tr-class="rowClassSelecionado">
              <template #head(ID)>
                <SetFilter label="ID" v-model="filtros.ID" :options="opcoes.ID" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #cell(DETALHE)="row">
                <b-button
                  variant="link"
                  class="p-0 text-secondary"
                  :title="row.detailsShowing ? 'Ocultar itens da fórmula' : 'Mostrar itens da fórmula'"
                  @click.stop="toggleDetalhesFormula(row)">
                  <i :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
                </b-button>
              </template>

              <template #head(DESCRICAO)>
                <SetFilter label="Descrição" v-model="filtros.DESCRICAO" :options="opcoes.DESCRICAO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(PRODUTO_CODIGONOME)>
                <SetFilter label="Produto Final" v-model="filtros.PRODUTO_CODIGONOME" :options="opcoes.PRODUTO_CODIGONOME" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(SITUACAO_LABEL)>
                <SetFilter label="Situação" v-model="filtros.SITUACAO_LABEL" :options="opcoes.SITUACAO_LABEL" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #cell(QUANT_PADRAO)="row">
                <span class="text-right d-block">{{ formatarNumero(row.item.QUANT_PADRAO) }}</span>
              </template>

              <template #cell(RENDIMENTO_PERC)="row">
                <span class="text-right d-block font-weight-bold text-info">{{ formatarNumero(row.item.RENDIMENTO_PERC) }}%</span>
              </template>

              <template #cell(SITUACAO_LABEL)="row">
                <b-badge :variant="getVariantStatus(row.item.OP_SITUACAO)" pill>{{ row.item.SITUACAO_LABEL }}</b-badge>
              </template>

              <template #row-details="row">
                <div class="p-3 bg-light border-top border-bottom">
                  <div v-if="row.item.loading" class="text-center p-3">
                    <b-spinner small variant="primary" /> Carregando itens da fórmula...
                  </div>

                  <div v-else>
                    <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3 gap-2">
                      <div>
                        <h6 class="modal-section-title mb-1">Itens da Fórmula</h6>
                        <small class="text-muted">{{ row.item.PRODUTO_CODIGONOME }}</small>
                      </div>
                      <b-badge variant="info" pill class="px-3 py-2 align-self-start align-self-md-center">
                        {{ (row.item.detalhes || []).length }} item(ns)
                      </b-badge>
                    </div>

                    <div v-if="!(row.item.detalhes || []).length" class="text-muted small bg-white border rounded p-3">
                      Esta fórmula ainda não possui itens cadastrados.
                    </div>

                    <b-table
                      v-else
                      class="mb-0 bg-white rounded shadow-xs"
                      small
                      hover
                      responsive
                      :items="row.item.detalhes"
                      :fields="colunasDetalhes">
                      <template #cell(QUANTIDADE)="detailRow">
                        <span class="text-right d-block">{{ formatarNumero(detailRow.item.QUANTIDADE, 3) }}</span>
                      </template>

                      <template #cell(PECAS)="detailRow">
                        <span class="text-center d-block">{{ formatarInteiro(detailRow.item.PECAS) }}</span>
                      </template>

                      <template #cell(PERCENTUAL)="detailRow">
                        <span class="text-right d-block">{{ formatarNumero(detailRow.item.PERCENTUAL) }}%</span>
                      </template>

                      <template #cell(OP_OBRIGA_LOTE)="detailRow">
                        <b-badge :variant="String(detailRow.item.OP_OBRIGA_LOTE || '0') === '1' ? 'warning' : 'secondary'" pill>
                          {{ String(detailRow.item.OP_OBRIGA_LOTE || '0') === '1' ? 'Sim' : 'Não' }}
                        </b-badge>
                      </template>

                      <template #cell(OBSERVACAO)="detailRow">
                        <span class="text-muted small">{{ detailRow.item.OBSERVACAO || '-' }}</span>
                      </template>
                    </b-table>
                  </div>
                </div>
              </template>

              <template #cell(actions)="item">
                <div class="d-flex justify-content-center gap-1">
                  <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                    <i class="fa fa-pencil"></i>
                  </b-button>
                  <b-button type="button" @click.stop.prevent="abrirModalCancelar(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Cancelar" v-b-tooltip.hover>
                    <i class="fa fa-ban"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal
      ref="modalCancelar"
      title="Cancelar Fórmula"
      ok-variant="danger"
      ok-title="Sim, cancelar"
      cancel-title="Não"
      centered
      @ok="cancelar">
      <div v-if="itemCancelar">
        <p class="mb-2">Deseja realmente cancelar esta fórmula?</p>
        <div class="card bg-light">
          <div class="card-body">
            <p class="mb-1"><strong>ID:</strong> {{ itemCancelar.ID }}</p>
            <p class="mb-1"><strong>Descrição:</strong> {{ itemCancelar.DESCRICAO }}</p>
            <p class="mb-0"><strong>Produto Final:</strong> {{ itemCancelar.PRODUTO_CODIGONOME }}</p>
          </div>
        </div>
        <div class="mt-3">
          <label class="font-weight-bold">Motivo do cancelamento</label>
          <b-form-textarea v-model="motivoCancelamento" rows="3" placeholder="Informe o motivo, se necessário"></b-form-textarea>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import ProducaoFormulaProdutoDropDown from './ProducaoFormulaProdutoDropDown.vue'

export default {
  components: {
    SetFilter,
    ProducaoFormulaProdutoDropDown
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: false,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'DESCRICAO', type: 'string', label: 'Descrição' },
      { key: 'PRODUTO_CODIGONOME', type: 'string', label: 'Produto Final' },
      { key: 'SITUACAO_LABEL', type: 'string', label: 'Situação' }
    ]
  })],
  data() {
    return {
      isBusy: false,
      filtroAvancado: false,
      itemCancelar: null,
      motivoCancelamento: '',
      situacaoOptions: [
        { value: '1', text: 'Ativas' },
        { value: '0', text: 'Canceladas' },
        { value: '', text: 'Todas' }
      ],
      colunas: [
        { key: 'DETALHE', label: '', class: 'text-center align-middle p-0', thStyle: { width: '40px' } },
        { key: 'ID', label: 'ID', sortable: true, class: 'text-center', thStyle: { width: '80px' } },
        { key: 'DESCRICAO', label: 'Descrição', sortable: true },
        { key: 'PRODUTO_CODIGONOME', label: 'Produto Final', sortable: true },
        { key: 'QUANT_PADRAO', label: 'Quantidade', sortable: true, class: 'text-right', thStyle: { width: '130px' } },
        { key: 'PECAS_PADRAO', label: 'Peças', sortable: true, class: 'text-center', thStyle: { width: '90px' } },
        { key: 'RENDIMENTO_PERC', label: 'Rendimento %', sortable: true, class: 'text-right', thStyle: { width: '130px' } },
        { key: 'TOTAL_ITENS', label: 'Itens', sortable: true, class: 'text-center', thStyle: { width: '90px' } },
        { key: 'SITUACAO_LABEL', label: 'Situação', sortable: true, class: 'text-center', thStyle: { width: '120px' } },
        { key: 'actions', label: 'Ações', class: 'text-center', thStyle: { width: '120px' } }
      ],
      colunasDetalhes: [
        { key: 'ORDEM', label: 'Ordem', class: 'text-center', thStyle: { width: '70px' } },
        { key: 'PRODUTO_CODIGONOME', label: 'Item' },
        { key: 'CENTRO_ESTOQUE_CODIGONOME', label: 'Centro de Estoque' },
        { key: 'QUANTIDADE', label: 'Consumo Base', class: 'text-right', thStyle: { width: '130px' } },
        { key: 'PECAS', label: 'Peças', class: 'text-center', thStyle: { width: '80px' } },
        { key: 'PERCENTUAL', label: '% Base', class: 'text-right', thStyle: { width: '100px' } },
        { key: 'OP_OBRIGA_LOTE', label: 'Lote', class: 'text-center', thStyle: { width: '80px' } },
        { key: 'OBSERVACAO', label: 'Observação' }
      ]
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    ...mapGetters('producaoFormula', [
      'LISTA',
      'FILTRO_DESCRICAO',
      'FILTRO_PRODUTO_ID',
      'FILTRO_SITUACAO',
      'REGISTRO_SELECIONADO_ID',
      'RECARREGAR_LISTA'
    ]),
    lista: {
      get() { return this.LISTA },
      set(v) { this.$store.commit('producaoFormula/SET_LISTA', v) }
    },
    textoPesquisa: {
      get() { return this.FILTRO_DESCRICAO },
      set(v) { this.$store.commit('producaoFormula/SET_FILTRO_DESCRICAO', v) }
    },
    filtroProdutoId: {
      get() { return this.FILTRO_PRODUTO_ID },
      set(v) { this.$store.commit('producaoFormula/SET_FILTRO_PRODUTO_ID', v) }
    },
    filtroSituacao: {
      get() { return this.FILTRO_SITUACAO },
      set(v) { this.$store.commit('producaoFormula/SET_FILTRO_SITUACAO', v) }
    }
  },
  mounted() {
    this.carregarTela()
  },
  activated() {
    if (this.RECARREGAR_LISTA) {
      this.carregarTela()
      this.$store.commit('producaoFormula/SET_RECARREGAR_LISTA', false)
    }
  },
  methods: {
    formatarNumero(valor, casas = 2) {
      return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas })
    },
    formatarInteiro(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    },
    getVariantStatus(situacao) {
      return String(situacao || '1') === '0' ? 'danger' : 'success'
    },
    async toggleDetalhesFormula(row) {
      if (row.detailsShowing) {
        row.toggleDetails()
        return
      }

      if (!row.item.detalhes && !row.item.loading) {
        this.$set(row.item, 'loading', true)
        try {
          const detalhes = await this.carregarDetalhesFormula(row.item.ID)
          this.$set(row.item, 'detalhes', detalhes)
        } catch (err) {
          this.$set(row.item, 'detalhes', [])
          this.$bvToast.toast(err?.response?.data || err?.message || 'Erro ao carregar itens da fórmula', {
            title: 'Erro',
            variant: 'danger',
            solid: true
          })
          return
        } finally {
          this.$set(row.item, 'loading', false)
        }
      }

      row.toggleDetails()
    },
    async carregarDetalhesFormula(formulaId) {
      const response = await this.$http.get(`/api/protected/producao-formula-item/listar/${formulaId}`)
      return response.data || []
    },
    clicarLinha(item) {
      this.$store.commit('producaoFormula/SET_REGISTRO_SELECIONADO_ID', item.ID)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      return item.ID === this.REGISTRO_SELECIONADO_ID ? 'cec-row-selected' : ''
    },
    novo() {
      this.$router.push('/producao/formula/add')
    },
    edit(item) {
      this.$router.push(`/producao/formula/edit/${item.ID}`)
    },
    async carregarTela() {
      await this.pesquisar()
    },
    async pesquisar() {
      this.isBusy = true
      try {
        await this.$store.dispatch('producaoFormula/GET_LISTA')
      } catch (err) {
        this.$bvToast.toast(err?.response?.data || 'Erro ao carregar fórmulas', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.isBusy = false
      }
    },
    limparFiltro() {
      this.$store.commit('producaoFormula/SET_LIMPAR')
      this.pesquisar()
    },
    abrirModalCancelar(item) {
      if (String(item.OP_SITUACAO || '1') === '0') {
        this.$bvToast.toast('Esta fórmula já está cancelada', {
          title: 'Aviso',
          variant: 'warning',
          solid: true
        })
        return
      }
      this.itemCancelar = item
      this.motivoCancelamento = ''
      this.$refs.modalCancelar.show()
    },
    async cancelar() {
      try {
        await this.$http.post('/api/protected/producao-formula/cancelar', {
          id: this.itemCancelar.ID,
          login: window.localStorage.getItem('login') || 'SISTEMA',
          motivo: this.motivoCancelamento
        })
        this.$bvToast.toast('Fórmula cancelada com sucesso', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })
        await this.pesquisar()
      } catch (err) {
        this.$bvToast.toast(err?.response?.data || 'Erro ao cancelar fórmula', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    }
  }
}
</script>

<style scoped>
.form-search-wrapper {
  min-width: 280px;
}

.table-finance tbody td {
  vertical-align: middle !important;
}

@media (max-width: 768px) {
  .form-search-wrapper {
    min-width: 100%;
    border-left: 0 !important;
    margin-right: 0 !important;
    padding: 0.5rem 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/producao/producao-formula/ProducaoFormulaListagem.vue